<template>
    <div class="row">
            <div class="col-md-12">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <table class="table" id="tabela">
                            <tbody>
                                <template v-for="iterator of report">
                                    <tr :key="iterator.id+100" >
                                        <td class="headerLine text-right"> <b>Loja:</b> </td>
                                        <td colspan="6">{{ iterator.name }}</td>
                                    </tr>

                                    <template v-for="team of iterator.teams">
                                        <template v-if="team.goals.length">
                                            <tr :key="team.id+200">
                                                <td class="headerLine text-right"> <b>Equipe:</b> </td>
                                                <td colspan="6">{{ team.name }}</td>
                                            </tr>

                                            <template v-for="goal of team.goals">
                                                <template v-if="goal.persons.length">
                                                        <tr :key="goal.id+300">
                                                            <td class="headerLine text-right">Meta:</td>
                                                            <td>{{ goal.date_init | moment('DD/MM/YYYY') }} até {{ goal.date_end | moment('DD/MM/YYYY') }} - {{ goal.description }} ({{ goal.goal }})</td>
                                                        </tr>
                                                        <tr :key="goal.id+'_'">
                                                            <td class="headerLine text-center">Ranking</td>
                                                            <td class="headerLine text-left">
                                                                <span>{{ orderVendedor }}</span>
                                                                <a href="javascript:;" @click="onOrder('users.name')">Vendedor</a>
                                                            </td>
                                                            <td class="headerLine text-center">Meta</td>
                                                            <td class="headerLine text-center">
                                                                <span>{{ orderRealizado }}</span>
                                                                <a href="javascript:;" @click="onOrder('qtd_vendas')">Realizado</a>
                                                            </td>
                                                            <td class="headerLine text-center">
                                                                <span>{{ orderTotalVendas }}</span>
                                                                <a href="javascript:;" @click="onOrder('total_vendas')">Total de Vendas</a>
                                                            </td>
                                                            <td class="headerLine text-center">
                                                                <span>{{ orderTicketMedio }}</span>
                                                                <a href="javascript:;" @click="onOrder('ticket_medio')">Tíket Médio</a>
                                                            </td>
                                                            <td class="headerLine text-center">Status Meta</td>
                                                        </tr>

                                                        
                                                        <template v-for="(person, key) of goal.persons">
                                                            <tr :key="key+400">
                                                            <td class="text-center">{{key + 1}} º</td>
                                                            <td class="text-left">{{ person.user_name }}</td>
                                                            <td class="text-center">{{ goal.goal }}</td>
                                                            <td class="text-center">{{ person.qtd_vendas }}</td>
                                                            <td class="text-right">{{ person.total_vendas | price}}</td>
                                                            <td class="text-right">{{ (person.total_vendas / person.qtd_vendas) | price}}</td>
                                                            <td class="text-center">{{ (person.qtd_vendas - goal.goal) }}</td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                
                                                </template>
                                        </template>
                                        

                                    </template>


                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
</template>

<style>
.headerLine a{
    color: #67757c;
    text-decoration: underline;
}
</style>

<script>
export default {
    created() {
        
    },
    props : {
        onOrder: {
            type: Function
        },
        orderRealizado: {
            type: String,
            default: '-'
        },
        orderTicketMedio: {
            type: String,
            default: '-'
        },
        orderTotalVendas: {
            type: String,
            default: '-'
        },
        orderVendedor: {
            type: String,
            default: '-'
        },
        report : {
            type : Array,
            default : []
        }
    }
}
</script>